
import Layout from "../../components/feature/Layout";
import { useState } from "react";

export default function PortalHome() {
  const [showAlertDetail, setShowAlertDetail] = useState(false);

  const kpis = [
    { label: "Operaciones Activas", value: "8", icon: "ri-ship-line", color: "#2F80ED", trend: "+2 esta semana" },
    { label: "En Aduana", value: "3", icon: "ri-building-2-line", color: "#EAB308", trend: "2 por liberar" },
    { label: "Finalizadas (Mes)", value: "12", icon: "ri-checkbox-circle-line", color: "#10B981", trend: "+15% vs mes anterior" },
    { label: "Docs. Pendientes", value: "5", icon: "ri-file-warning-line", color: "#EF4444", trend: "Requieren atención" },
    { label: "Saldo Pendiente", value: "$45,280", icon: "ri-money-dollar-circle-line", color: "#8B5CF6", trend: "3 facturas" },
    { label: "Último Movimiento", value: "Hoy", icon: "ri-time-line", color: "#06B6D4", trend: "OP-2024-0156" },
  ];

  const recentOperations = [
    { id: "OP-2024-0156", type: "Importación", status: "En Tránsito", aduana: "Veracruz", eta: "2024-01-20", gestor: "María López", progress: 65 },
    { id: "OP-2024-0155", type: "Exportación", status: "En Aduana", aduana: "Manzanillo", eta: "2024-01-18", gestor: "Carlos Ruiz", progress: 80 },
    { id: "OP-2024-0154", type: "Importación", status: "Despacho", aduana: "AICM", eta: "2024-01-17", gestor: "María López", progress: 90 },
    { id: "OP-2024-0153", type: "Importación", status: "Finalizada", aduana: "Laredo", eta: "2024-01-15", gestor: "Ana García", progress: 100 },
  ];

  const alerts = [
    { id: 1, type: "warning", title: "Documento pendiente", message: "Falta certificado de origen para OP-2024-0156", time: "Hace 2 horas" },
    { id: 2, type: "info", title: "Operación actualizada", message: "OP-2024-0155 llegó a puerto de destino", time: "Hace 4 horas" },
    { id: 3, type: "success", title: "Pago confirmado", message: "Se aplicó pago de $15,680 a su cuenta", time: "Ayer" },
    { id: 4, type: "error", title: "Factura vencida", message: "FC-2024-0078 venció hace 5 días", time: "Hace 5 días" },
  ];

  const quickActions = [
    { label: "Ver Operaciones", icon: "ri-ship-line", path: "/portal/operations" },
    { label: "Mis Documentos", icon: "ri-folder-line", path: "/portal/documents" },
    { label: "Estado de Cuenta", icon: "ri-wallet-line", path: "/portal/statements" },
    { label: "Enviar Mensaje", icon: "ri-message-2-line", path: "/portal/messages" },
    { label: "Crear Ticket", icon: "ri-customer-service-line", path: "/portal/support" },
    { label: "Mi Perfil", icon: "ri-user-line", path: "/portal/profile" },
  ];

  const getAlertIcon = (type: string) => {
    switch (type) {
      case "warning": return "ri-alert-line";
      case "info": return "ri-information-line";
      case "success": return "ri-checkbox-circle-line";
      case "error": return "ri-error-warning-line";
      default: return "ri-notification-line";
    }
  };

  const getAlertColor = (type: string) => {
    switch (type) {
      case "warning": return "#EAB308";
      case "info": return "#2F80ED";
      case "success": return "#10B981";
      case "error": return "#EF4444";
      default: return "#6B7280";
    }
  };

  return (
    <Layout>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-[#0A2A43]">Bienvenido, Importadora del Norte S.A.</h1>
            <p className="text-sm text-gray-500 mt-1">Portal de Cliente • Última conexión: Hoy 09:45 AM</p>
          </div>
          <div className="flex items-center gap-3">
            <button className="px-4 py-2 border border-gray-200 text-[#6B7280] rounded-lg hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2">
              <i className="ri-download-line"></i>
              Descargar Resumen
            </button>
            <button className="px-4 py-2 bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white rounded-lg hover:opacity-90 transition-opacity cursor-pointer whitespace-nowrap flex items-center gap-2">
              <i className="ri-add-line"></i>
              Nueva Solicitud
            </button>
          </div>
        </div>

        {/* KPIs */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {kpis.map((kpi, index) => (
            <div key={index} className="bg-white rounded-lg p-4 shadow-[0_4px_16px_rgba(10,42,67,0.08)] hover:shadow-lg transition-shadow">
              <div className="flex items-center justify-between mb-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg" style={{ backgroundColor: `${kpi.color}15` }}>
                  <i className={`${kpi.icon} text-xl`} style={{ color: kpi.color }}></i>
                </div>
              </div>
              <p className="text-2xl font-bold text-[#0A2A43]">{kpi.value}</p>
              <p className="text-xs text-gray-500 mt-1">{kpi.label}</p>
              <p className="text-xs mt-2" style={{ color: kpi.color }}>{kpi.trend}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Timeline Operaciones */}
          <div className="lg:col-span-2 bg-white rounded-lg shadow-[0_4px_16px_rgba(10,42,67,0.08)]">
            <div className="p-6 border-b border-gray-100">
              <div className="flex items-center justify-between">
                <h2 className="text-lg font-bold text-[#0A2A43]">Línea de Tiempo - Operaciones Recientes</h2>
                <a href="/portal/operations" className="text-sm text-[#2F80ED] hover:underline cursor-pointer">Ver todas</a>
              </div>
            </div>
            <div className="p-6">
              <div className="space-y-4">
                {recentOperations.map((op) => (
                  <div key={op.id} className="relative pl-8 pb-4 border-l-2 border-gray-200 last:border-l-0 last:pb-0">
                    <div className={`absolute left-[-9px] top-0 w-4 h-4 rounded-full border-2 border-white ${
                      op.status === "Finalizada" ? "bg-[#10B981]" :
                      op.status === "En Aduana" ? "bg-[#EAB308]" :
                      op.status === "Despacho" ? "bg-[#8B5CF6]" :
                      "bg-[#2F80ED]"
                    }`}></div>
                    <div className="bg-gray-50 rounded-lg p-4 hover:bg-gray-100 transition-colors cursor-pointer">
                      <div className="flex items-center justify-between mb-2">
                        <div className="flex items-center gap-3">
                          <span className="text-sm font-semibold text-[#0A2A43]">{op.id}</span>
                          <span className="px-2 py-0.5 text-xs font-medium rounded-full bg-[#EAF2F8] text-[#2F80ED]">{op.type}</span>
                        </div>
                        <span className={`px-2.5 py-1 rounded-full text-xs font-medium whitespace-nowrap ${
                          op.status === "Finalizada" ? "bg-[#10B981]/10 text-[#10B981]" :
                          op.status === "En Aduana" ? "bg-[#EAB308]/10 text-[#EAB308]" :
                          op.status === "Despacho" ? "bg-[#8B5CF6]/10 text-[#8B5CF6]" :
                          "bg-[#2F80ED]/10 text-[#2F80ED]"
                        }`}>
                          {op.status}
                        </span>
                      </div>
                      <div className="flex items-center justify-between text-xs text-gray-500">
                        <span><i className="ri-building-2-line mr-1"></i>{op.aduana}</span>
                        <span><i className="ri-calendar-line mr-1"></i>ETA: {op.eta}</span>
                        <span><i className="ri-user-line mr-1"></i>{op.gestor}</span>
                      </div>
                      <div className="mt-3 flex items-center gap-2">
                        <div className="flex-1 h-2 bg-gray-200 rounded-full overflow-hidden">
                          <div
                            className="h-full bg-gradient-to-r from-[#114B7A] to-[#2F80ED] transition-all"
                            style={{ width: `${op.progress}%` }}
                          ></div>
                        </div>
                        <span className="text-xs font-semibold text-[#2F80ED]">{op.progress}%</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Alertas y Accesos Rápidos */}
          <div className="space-y-6">
            {/* Alertas */}
            <div className="bg-white rounded-lg shadow-[0_4px_16px_rgba(10,42,67,0.08)]">
              <div className="p-4 border-b border-gray-100">
                <div className="flex items-center justify-between">
                  <h2 className="text-lg font-bold text-[#0A2A43]">Alertas</h2>
                  <span className="px-2 py-0.5 text-xs font-semibold bg-[#EF4444] text-white rounded-full">{alerts.length}</span>
                </div>
              </div>
              <div className="p-4 space-y-3 max-h-[280px] overflow-y-auto">
                {alerts.map((alert) => (
                  <div
                    key={alert.id}
                    className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer"
                    onClick={() => setShowAlertDetail(true)}
                  >
                    <div
                      className="w-8 h-8 flex items-center justify-center rounded-lg flex-shrink-0"
                      style={{ backgroundColor: `${getAlertColor(alert.type)}15` }}
                    >
                      <i className={`${getAlertIcon(alert.type)} text-lg`} style={{ color: getAlertColor(alert.type) }}></i>
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-medium text-[#0A2A43]">{alert.title}</p>
                      <p className="text-xs text-gray-500 truncate">{alert.message}</p>
                      <p className="text-xs text-gray-400 mt-1">{alert.time}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Accesos Rápidos */}
            <div className="bg-white rounded-lg shadow-[0_4px_16px_rgba(10,42,67,0.08)]">
              <div className="p-4 border-b border-gray-100">
                <h2 className="text-lg font-bold text-[#0A2A43]">Accesos Rápidos</h2>
              </div>
              <div className="p-4 grid grid-cols-2 gap-3">
                {quickActions.map((action, index) => (
                  <a
                    key={index}
                    href={action.path}
                    className="flex flex-col items-center gap-2 p-4 rounded-lg border border-gray-100 hover:border-[#2F80ED] hover:bg-[#EAF2F8] transition-all cursor-pointer"
                  >
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-[#EAF2F8]">
                      <i className={`${action.icon} text-xl text-[#2F80ED]`}></i>
                    </div>
                    <span className="text-xs font-medium text-[#0A2A43] text-center">{action.label}</span>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal Detalle Alerta */}
      {showAlertDetail && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg w-full max-w-md mx-4">
            <div className="p-6 border-b border-gray-200 flex items-center justify-between">
              <h2 className="text-lg font-bold text-[#0A2A43]">Detalle de Alerta</h2>
              <button onClick={() => setShowAlertDetail(false)} className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-gray-100 cursor-pointer">
                <i className="ri-close-line text-xl text-[#6B7280]"></i>
              </button>
            </div>
            <div className="p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-[#EAB308]/10">
                  <i className="ri-alert-line text-2xl text-[#EAB308]"></i>
                </div>
                <div>
                  <p className="text-lg font-semibold text-[#0A2A43]">Documento pendiente</p>
                  <p className="text-sm text-gray-500">Hace 2 horas</p>
                </div>
              </div>
              <p className="text-sm text-gray-600 mb-4">
                Falta certificado de origen para la operación OP-2024-0156. Por favor, suba el documento lo antes posible para evitar retrasos en el despacho aduanal.
              </p>
              <div className="p-3 bg-gray-50 rounded-lg">
                <p className="text-xs text-gray-500 mb-1">Operación relacionada</p>
                <p className="text-sm font-semibold text-[#0A2A43]">OP-2024-0156 - Importación Veracruz</p>
              </div>
            </div>
            <div className="p-6 border-t border-gray-200 flex justify-end gap-3">
              <button onClick={() => setShowAlertDetail(false)} className="px-4 py-2 border border-gray-200 text-[#6B7280] rounded-md hover:bg-gray-50 cursor-pointer whitespace-nowrap">
                Cerrar
              </button>
              <button className="px-4 py-2 bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white rounded-md hover:shadow-md cursor-pointer whitespace-nowrap">
                <i className="ri-upload-line mr-2"></i>Subir Documento
              </button>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}
